

<div class="table-responsive w-100">

  <table class="table table-responsive table-striped table-borderless mb-0 w-100 d-block d-sm-table">
    <thead>
      <tr>
        <th>{{"COLORSCODE.TURBINE_COLORCODE" |translate}}</th>
        <th>{{"COLORSCODE.SHORT_DESCRIPTION" |translate}}</th>
        <th>{{"COLORSCODE.EXPLANATION" |translate}}</th>
      </tr>
    </thead>
    <tbody>
      @for (colour of colours; track colour) {
        <tr>
          <td class="text-primary text-nowrap" style="width: 15%">
            {{colour.code | colorStatusCode: 'colorName' |translate}}
          </td>
          <td class="text-primary text-nowrap" style="width: 15%">
            <i class="fas fa-circle mr-1" [ngStyle]="{'color': colour.code | colorStatusCode: 'color' }" [ngClass]="{ 'outline-circle': colour.code === 5 }"></i>
            {{colour.code | colorStatusCode: 'description' |translate}}
          </td>
          <td class="text-primary" style="width: 70%">
            <div [matTooltip]="colour.example |translate">
              {{ colour.explanation ? (colour.explanation | translate) : '' }}
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>